import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// import { Recorder } from 'react-voice-recorder';
import ReactAudioPlayer from "react-audio-player";
import Button from "@material-ui/core/Button";
import {
  MAX_FILE_SIZE,
  MIN_FILE_SIZE,
  API_URL,
} from "./../../service/constants/constants";
import Recorder from "./../../Components/Recorder/Recorder";
import cookie from "react-cookies";
import { Header } from "./../../Components/index";
import { Loader } from "./../../Components";
import {
  setPageName,
  isAudioUploaded,
  getTranscriptTobeDownloaded,
} from "./../../service/action/audio-track-action";

class RecordAudio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      audioURL: null,
      idToBeRecorded: null,
      audioDetails: {
        url: null,
        blob: null,
        chunks: null,
        duration: {
          h: 0,
          m: 0,
          s: 0,
        },
      },
    };
  }

  componentWillMount() {
    const {
      userLogin: { loggedUser },
    } = this.props;
    this.props.setPageName("Record New Audio");
    this.props.getTranscriptTobeDownloaded(
      cookie.load("username") || loggedUser.username
    );
  }

  componentWillReceiveProps(nextProps) {
    const {
      userLogin: { loggedUser },
    } = this.props;
    if (
      this.props.UserManagement.success.message !==
        nextProps.UserManagement.success.message &&
      !nextProps.UserManagement.loading
    ) {
      const reset = {
        url: null,
        blob: null,
        chunks: null,
        duration: {
          h: 0,
          m: 0,
          s: 0,
        },
      };
      this.setState({ audioDetails: reset, idToBeRecorded: null });
      this.props.getTranscriptTobeDownloaded(
        cookie.load("username") || loggedUser.username
      );
    }
  }

  handleAudioUpload(file) {
    console.log("File Information", file);
    const { audioDetails } = this.state;
    const {
      userLogin: { loggedUser },
    } = this.props;
    if (
      audioDetails.blob !== null &&
      audioDetails.blob.size <= MAX_FILE_SIZE &&
      audioDetails.blob.size > MIN_FILE_SIZE &&
      this.state.idToBeRecorded !== null &&
      file !== null
    ) {
      this.props.isAudioUploaded(
        this.state.idToBeRecorded,
        cookie.load("username") || loggedUser.username,
        audioDetails.blob
      );
    } else {
      alert(
        this.state.idToBeRecorded === null
          ? "Select the transcription to be Recorded!!"
          : audioDetails.blob === null
          ? "Seems you are not yet recorded!"
          : audioDetails.blob.size < MIN_FILE_SIZE
          ? "Recorded file size not have minimum size."
          : "Recorded file size exits maximum size."
      );
    }
  }

  handleRest() {
    const reset = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: 0,
        m: 0,
        s: 0,
      },
    };
    this.setState({ audioDetails: reset });
  }

  handleAudioStop(data) {
    console.log(data.blob.size);
    this.setState({ audioDetails: data });
  }

  handleSkip(id) {
    console.log(id);
    const {
      userLogin: { loggedUser },
    } = this.props;
    this.props.getTranscriptTobeDownloaded(
      cookie.load("username") || loggedUser.username
    );
    const userId = cookie.load("username");
    const TranscriptId = id;
    const requestOptions = {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ TranscriptId, userId }),
    };
    fetch(`${API_URL}/skip-recording`, requestOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  renderTranscriptItem(list) {
    console.log(list);
    const { idToBeRecorded } = this.state;
    return list.map((data, i) => {
      return (
        <li
          key={i}
          onClick={() => this.setState({ idToBeRecorded: data.id })}
          className={`trans-list-item ${
            idToBeRecorded === data.id ? "active" : ""
          }`}
        >
          <Button
            variant="contained"
            color="primary"
            disableElevation
            onClick={() => this.handleSkip(data.id)}
          >
            Skip
          </Button>
          <h4>{data.language}</h4>
          <a
            href="# "
            className={`${idToBeRecorded === data.id ? "active" : ""}`}
          >
            {data.transcript}
          </a>
          <br />
          <br />
          <h4>Sample Recording</h4>
          <ReactAudioPlayer src={data.filepath} controls />
        </li>
      );
    });
  }

  render() {
    const {
      page,
      UserManagement: { transcriptToBeRecorded, loading },
    } = this.props;
    return (
      <div className="right-section record-new-audio">
        <Header page="Audio Record" />
        {loading ? (
          <Loader />
        ) : (
          <div>
            <h2 className="trans-list-heading">
              Choose Transcription text to record
            </h2>
            <ul className="trans-list">
              {this.renderTranscriptItem(transcriptToBeRecorded.data)}
            </ul>
            <Recorder
              record={true}
              title={"New recording"}
              showUIAudio
              audioURL={this.state.audioDetails.url}
              handleAudioStop={(data) => this.handleAudioStop(data)}
              handleAudioUpload={(data) => this.handleAudioUpload(data)}
              handleRest={() => this.handleRest()}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    AudioToTrackReducer,
    userLogin,
    page,
    UserManagement,
    adminDashBoard,
  } = state;
  return {
    AudioToTrackReducer,
    userLogin,
    page,
    UserManagement,
    adminDashBoard,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    setPageName,
    getTranscriptTobeDownloaded,
    isAudioUploaded,
  })(RecordAudio)
);
